// webmd.firstImpression.js
// DEPENDENCIES: 


import { isNewVisit } from 'webmd-visit';
import { remove, get } from 'webmd-ads-cookie';
import debug from 'webmd-debug';

let init;
let followingImpression;
let checkNewVisit;
let setTopicImpression;
let setPageTargets;
let addLotameMeta;
let siteImpression;
let siteImpressionTarget;
let topicImpression;
let visitedTopics;
let topicImpressionTarget;
let followingImpressionTarget;


if ( typeof window !== 'undefined' ) {
  /**
   * @namespace
   */

  /**
   * First impression value
   * @type {Number}
   */
  siteImpression = 0;

  /** First impression value
   * @type {Number}
   */
  siteImpressionTarget = 'fis';

  /**
   * First impression topic
   * @type {Array}
   */
  topicImpression = '';

  /**
   * List of topics visited
   * @type {Array}
   */
  visitedTopics = [];

  /**
   * Page target to use for primary topic impressions in DFP
   * @type {String}
   */
  topicImpressionTarget = 'fipt';

  /**
   * Page target to use for first impression following in DFP
   * Value is set by Ad Server
   * @type {String}
   */
  followingImpressionTarget = 'fif';

  /**
   * Call to create the first impression cookie
   */
  init = function() {

    // If we are inside of an iframe, get out as we don't want to run any of this code
    if (top.location !== location) {
      return;
    }

    checkNewVisit();
    setTopicImpression();
    setPageTargets();
    addLotameMeta();

    // run firstImpression before every ad refresh
    document.addEventListener('before_adrefresh', function() {
      if (window.webmd.ads.initialLoadDisabled) {
        if(typeof(window.firstAdReceived) != 'undefined' && window.firstAdReceived === true){
          checkNewVisit();
          setTopicImpression();
          setPageTargets();
        }
      } else {
        checkNewVisit();
        setTopicImpression();
        setPageTargets();
      }
    });
  };

  /**
   * reset the values on new visit
   */
  checkNewVisit = function() {
    let storage = window.localStorage;

    if (isNewVisit()) {
      siteImpression = 1;

      followingImpression = null;
      remove({type:'sess', prefix:'fi'});

      visitedTopics = [];

      if (storage) {
        storage.removeItem(topicImpressionTarget);
      }
    } else {
      siteImpression = 0;

      if (get('sess') && get('sess').fi) {
        followingImpression = Object.keys(get('sess').fi).toString();
      }
    }
  };

  /**
   * set the topicImpression and save the topics vistited to localStorage, which only
   * supports strings, so need to use JSON.parse and JSON.stringify to make it save arrays
   */
  setTopicImpression = function() {
    let storage = window.localStorage;
    let topic = window.s_topic || window.s_channel;

    topicImpression = 0;

    if (storage && topic) {
      visitedTopics = storage.getItem(topicImpressionTarget) ? JSON.parse(storage.getItem(topicImpressionTarget)) : [];

      // set the topic impression if not visitied yet
      if (visitedTopics.indexOf(topic) === -1) {
        topicImpression = topic;
        visitedTopics.push(topic);
        // Adding Try/Catch to fix localStorage issue in Safari private
        // browsing browser & devices
        try {
          storage.setItem(topicImpressionTarget, JSON.stringify(visitedTopics));
        } catch(e){}
      }
    }
  };

  /**
   * Set DFP page targets
   */
  setPageTargets = function() {

    debug('site impression: ' + siteImpression);
    debug('topic impression: ' + topicImpression);
    debug('following impression: ' + followingImpression);

	if(window && window.webmd && window.webmd.ads) {
		window.webmd.ads.setPageTarget(siteImpressionTarget, siteImpression );
		window.webmd.ads.setPageTarget(topicImpressionTarget, topicImpression );
	
		if (followingImpression) {
			window.webmd.ads.setPageTarget(followingImpressionTarget, followingImpression );
		}
	}
  };

  /**
   *  If first impression, add meta tag to page head that includes current topic
   */
  addLotameMeta = function(){

    if (siteImpression === 1) {
      let meta = document.createElement('meta');
      meta.name = 's_1stimp';
      meta.content = topicImpression;
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  };

  init();
}